import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";

import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBRow,
  MDBCol,
  MDBCardText,
} from "mdbreact";
// import content from "../Helpers/home-content-data"
import sri from "../assets/sri_image.png";
import swsi from "../assets/swsi1.png";
import sgwi from "../assets/sgwi.png";
import chdi from "../assets/chdi.png";
import srsi from "../assets/srsi.png";
class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // let cards= content.items.map((item, key)=>{
    //     return(
    //         <MDBCol size="6" sm="4"  key={key}>

    //             <MDBCard>

    //                 <MDBCardBody style={{textAlign:"justify"}}>
    //                     <MDBCardTitle style={{color:"blue"}}>{item.caption}</MDBCardTitle>

    //                     {/* <MDBCardText style={{textAlign:"justify"}}> */}
    //                                                         {item.description}
    //                     {/* </MDBCardText> */}
    //                     {/* <div style={{align:"right"}}><h6 >More</h6></div> */}
    //                 </MDBCardBody>
    //             </MDBCard>

    //         </MDBCol>
    //     )

    // })
    return (
      <React.Fragment>
        <div style={{ padding: "10px", marginBottom: "10px" }}>
          <MDBRow>
            <MDBCol  md="4" style={{marginTop:"2px"}}>
              <MDBCard>
                <MDBCardBody style={{ textAlign: "center" }}>
                  <MDBCardTitle style={{ color: "blue" }}>
                    Standardized Runoff Index
                  </MDBCardTitle>
                  <img
                    src={sri}
                    style={{
                      float: "left",
                      marginTop: "5px",
                      marginBottom: "5px",
                      marginRight: "5px",
                      height: "106px",
                      width: "106px",
                    }}
                    alt="sri"
                  />

                  <MDBCardText
                    style={{ textAlign: "justify", fontSize: "0.8rem" }}
                  >
                    Standardized runoff index (SRI) is the unit standard normal
                    deviate associated with the percentile of hydrologic runoff.
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol md="4" style={{marginTop:"2px"}}>
              <MDBCard>
                <MDBCardBody style={{ textAlign: "justify" }}>
                  <MDBCardTitle style={{ color: "black", textAlign: "center" }}>
                    Standardized Water Spread Index
                  </MDBCardTitle>
                  <img
                    src={swsi}
                    style={{
                      float: "left",
                      marginTop: "5px",
                      marginBottom: "5px",
                      marginRight: "5px",
                      height: "106px",
                      width: "106px",
                    }}
                    alt="swsi"
                  />
                  <MDBCardText
                    style={{ textAlign: "justify", textJustify: "newspaper" }}
                  >
                    Satellite derived surface water spread area is used to
                    estimate the abnormalities related to availability of
                    surface water resources.
                  </MDBCardText>
                  {/* Satellite derived surface water spread area is used to estimate the abnormalities related to availability of surface water resources.</MDBCardText> */}
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol  md="4" style={{marginTop:"2px"}}>
              <MDBCard>
                <MDBCardBody style={{ textAlign: "center" }}>
                  <MDBCardTitle style={{ color: "blue" }}>
                    Standardized Ground-water Index
                  </MDBCardTitle>
                  <img
                    src={sgwi}
                    style={{
                      float: "left",
                      marginTop: "5px",
                      marginBottom: "5px",
                      marginRight: "5px",
                      height: "106px",
                      width: "106px",
                    }}
                    alt="sgwi"
                  />
                  <MDBCardText style={{ textAlign: "justify" }}>
                    Standardized Groundwater Index (SGWI) is used to estimate
                    the abnormalities related to usual ground-water levels in a
                    region
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </div>
        <div style={{ padding: "10px", marginBottom: "10px" }}>
          <MDBRow center>
            <MDBCol  md="4" style={{marginTop:"2px"}}>
              <MDBCard>
                <MDBCardBody style={{ textAlign: "center" }}>
                  <MDBCardTitle style={{ color: "blue" }}>
                    Standardized Reservoir Storage Index
                  </MDBCardTitle>
                  <img
                    src={srsi}
                    style={{
                      float: "left",
                      marginTop: "5px",
                      marginBottom: "5px",
                      height: "106px",
                      width: "106px",
                    }}
                    alt="srsi"
                  />
                  <MDBCardText style={{ textAlign: "justify" }}>
                    Standardized Reservoir Storage Index (SGWI) is used to
                    estimate the abnormalities related to usual reservoir levels
                    .
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol  md="4" style={{marginTop:"2px"}}>
              <MDBCard>
                <MDBCardBody style={{ textAlign: "center" }}>
                  <MDBCardTitle style={{ color: "blue" }}>
                    Composite Hydrological Drought Index
                  </MDBCardTitle>
                  <img
                    src={chdi}
                    style={{
                      float: "left",
                      marginTop: "5px",
                      marginBottom: "5px",
                      marginRight: "5px",
                      height: "106px",
                      width: "106px",
                    }}
                    alt="chdi"
                  />

                  <MDBCardText style={{ textAlign: "justify" }}>
                    A hybrid index generated by considering the impact of each
                    of the previously mentioned indicators on the ground.
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </div>
      </React.Fragment>
    );
  }
}

export default HomeCardDeck;
